import dateTimeFormat from "./format/dateTimeFormat";

export default {
  timeFormat(
    d: string | Date | undefined | null,
    format = "[y]-[m]-[d] [h]:[i]",
    utc = false
  ) {
    if (!d) {
      return "";
    }
    return dateTimeFormat(d, format, utc);
  },
  longDateFormat(d: string | Date | undefined | null, showDayName = true, utc = false) {
    if (!d) {
      return "";
    }
    const format = showDayName ? "[dn] [d] [mn] [y]" : "[mn] [d] [y]";
    return dateTimeFormat(d, format, utc);
  },
  getNumber(n?: number | null | undefined) {
    return n ? n : 0;
  },
  renderPercent(n?: number | null | undefined) {
    if (n === null || n === undefined) {
      return "";
    }
    return (n * 100).toFixed(1) + "%";
  },
  renderMoney(n?: number | null, currency = "£") {
    if (n === null || n === undefined) {
      return "";
    }
    return currency + n.toFixed(2);
  },
  formatNumber(n: number | null | undefined) {
    return new Intl.NumberFormat("en-GB", {
      maximumSignificantDigits: 2,
    }).format(this.getNumber(n));
  },
  buildPath(s: string) {
    return process.env.VUE_APP_URL + s;
  },
  buildMfPath(s: string) {
    const base =
      process.env.NODE_ENV === "production"
        ? "https://mathsframe.co.uk/"
        : "http://mf.localhost/";
    return base + s;
  },
  userRole(n: number) {
    const names = [
      "",
      "Sf Admin",
      "School Admin",
      "School Teacher",
      "School Student",
      "Sf Editor",
      "Sf Game Dev",
      "Individual Admin",
      "Individual",
      "Mathsframe School",
      "Mathsframe Individual",
    ];
    return names[n];
  },
};
